import { dateFilter } from "@/filters/dateFilter";
import { formatMoney } from "../CreditosClientes/helpers";

export { formatMoney };

export const DEBOUNCE_BUSCA_MS = 300;
export const ITENS_POR_PAGINA = 15;
export const LIMITE_EXPORTACAO = 20000;
export const TAMANHO_MAXIMO_NOME = 120;
export const TAMANHO_MAXIMO_CHAVE_RESTRICAO = 30;
export const PERCENTUAL_MAXIMO = 100;
export const DIAS_MAXIMO_AVISO = 365;
export const DURACAO_AVISO_SUCESSO_MS = 1800;
export const MS_POR_DIA = 86400000;

export const TIPOS_MOVIMENTO = {
  GANHO: "Cashback ganho",
  USO: "Cashback utilizado",
  ESTORNO_GANHO: "Estorno por cancelamento",
  EXPIRACAO: "Cashback expirado",
  ESTORNO_USO: "Cashback devolvido",
  AJUSTE: "Ajuste manual",
  ESTORNO_DEVOLUCAO: "Estorno por devolução",
};

export const ETIQUETA_MOVIMENTO = {
  GANHO: "cashback-etiqueta--ganho",
  USO: "cashback-etiqueta--uso",
  ESTORNO_GANHO: "cashback-etiqueta--estorno",
  EXPIRACAO: "cashback-etiqueta--expiracao",
  ESTORNO_USO: "cashback-etiqueta--devolucao",
  AJUSTE: "cashback-etiqueta--ajuste",
  ESTORNO_DEVOLUCAO: "cashback-etiqueta--estorno",
};

export const SITUACOES_SALDO = {
  POSITIVO: "Com saldo",
  ZERADO: "Zerado",
  NEGATIVO: "Negativo",
};

export const FILTRO_PENDENTE = "PENDENTE";

export const numero = (valor) => {
  const convertido = Number(valor);

  return Number.isNaN(convertido) ? 0 : convertido;
};

export const centavos = (valor) => Math.round(numero(valor) * 100);

export const positivo = (valor) => (Number(valor) > 0 ? Number(valor) : null);

export const tetoDaFaixa = (faixa) => positivo(faixa && faixa.valorMaximo);

export function formatPercentual(valor) {
  return `${numero(valor).toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%`;
}

export function descricaoFaixa(faixa) {
  const minimo = formatMoney(faixa.valorMinimo || 0);
  const percentual = numero(faixa.percentual) > 0 ? formatPercentual(faixa.percentual) : "sem cashback";
  const teto = tetoDaFaixa(faixa);

  return teto !== null ? `${minimo} a ${formatMoney(teto)}: ${percentual}` : `A partir de ${minimo}: ${percentual}`;
}

export function ordenarFaixas(faixas) {
  return [...(faixas || [])].sort((a, b) => numero(a.valorMinimo) - numero(b.valorMinimo));
}

export function rotulosPorChave(opcoes) {
  return (opcoes || []).reduce((mapa, opcao) => {
    mapa[opcao.chave] = opcao.label;

    return mapa;
  }, {});
}

export function novaRegra() {
  return {
    id: null,
    nome: "",
    descricao: "",
    ativo: true,
    prioridade: 0,
    dataInicio: null,
    dataFim: null,
    canais: [],
    validadeDias: 90,
    exigeSemTituloVencido: true,
    toleranciaDiasTituloVencido: 0,
    contagemDiasTituloVencido: "CORRIDOS",
    mediaAtrasoMaximaDias: null,
    mediaAtrasoMeses: null,
    limiteValorPedido: null,
    limiteValorCliente: null,
    limiteValorTotal: null,
    limitePeriodo: null,
    mensagemIncentivo: "",
    permiteComPromocao: true,
    permiteComPoliticaDesconto: true,
    permiteComCupom: true,
    permiteComCampanha: true,
    permiteComCredito: true,
    permiteComUsoCashback: false,
    baseComUso: "TOTAL",
    baseValor: "COM_IMPOSTO",
    comportamentoTeto: "SEM_CASHBACK",
    faixas: [{ valorMinimo: 0, valorMaximo: null, percentual: 1 }],
    restricoes: [],
  };
}

export function nomeCopia(nome) {
  return `Cópia de ${nome || ""}`.trim().substring(0, TAMANHO_MAXIMO_NOME);
}

export function formatDocumento(valor) {
  const digitos = String(valor || "").replace(/\D/g, "");

  if (digitos.length === 14) return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  if (digitos.length === 11) return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

  return valor || "";
}

export function formatData(valor, vazio = "—") {
  return valor ? dateFilter(String(valor).substring(0, 10)) : vazio;
}

export const DIAS_PADRAO_EXTRATO = 90;
export const DIAS_VALIDADE_LINK_EXTRATO = 7;

export function descricaoPeriodoExtrato({ dtIni, dtFim } = {}) {
  if (dtIni && dtFim) return `de ${formatData(dtIni)} a ${formatData(dtFim)}`;
  if (dtIni) return `de ${formatData(dtIni)} até hoje`;
  if (dtFim) return `nos ${DIAS_PADRAO_EXTRATO} dias até ${formatData(dtFim)}`;

  return `dos últimos ${DIAS_PADRAO_EXTRATO} dias`;
}

export function mensagemErroApi(erro) {
  const erros = erro && erro.apiResponse && erro.apiResponse.errors;

  if (erros && !Array.isArray(erros) && typeof erros === "object") {
    const mensagens = Object.values(erros).flat().filter(Boolean);

    if (mensagens.length) return mensagens.join("\n");
  }

  return (erro && erro.message) || "Erro inesperado.";
}

export const STATUS_VALIDACAO = 422;
export const EXEMPLO_SALDO_CARTEIRA = 500;
export const EXEMPLO_VALOR_PEDIDO = 1000;
export const LIMITE_USO_NENHUM = "NENHUM";
export const TIPOS_LIMITE_USO = [
  { chave: LIMITE_USO_NENHUM, label: "Sem limite", campo: null },
  { chave: "SALDO", label: "% do saldo", campo: "usoLimitePercentualSaldo", percentual: true },
  { chave: "PEDIDO", label: "% do pedido", campo: "usoLimitePercentualPedido", percentual: true },
  { chave: "VALOR", label: "Valor por pedido", campo: "usoLimiteValorPedido", percentual: false },
];
const CAMPOS_LIMITE_USO = TIPOS_LIMITE_USO.filter((tipo) => tipo.campo);

export const tipoLimiteUsoPorChave = (chave) => TIPOS_LIMITE_USO.find((tipo) => tipo.chave === chave) || TIPOS_LIMITE_USO[0];

export const MODO_USO_PADRAO = "CREDITO";

export function modosUsoDaApi(dados) {
  const modos = dados && dados.modosUso;

  if (!Array.isArray(modos)) return [];

  return modos
    .filter((modo) => modo && modo.chave)
    .map((modo) => ({ chave: modo.chave, label: modo.label || modo.chave, descricao: modo.descricao || "", suportado: !!modo.suportado }));
}

export function modoUsoBloqueado(modosUso, modo) {
  const encontrado = (modosUso || []).find((opcao) => opcao.chave === modo);

  return !!encontrado && !encontrado.suportado;
}

export const MENSAGEM_MODO_USO_BLOQUEADO = "Escolha uma forma de uso do saldo suportada pelo ERP antes de salvar.";

export const configuracaoVazia = () => ({
  avisoGanho: true,
  avisoGanhoEmail: true,
  avisoVencimento: false,
  avisoVencimentoDias: 5,
  avisoParaCliente: true,
  avisoParaOperador: false,
  avisoParaRepresentante: false,
  usoLimitePercentualSaldo: null,
  usoLimitePercentualPedido: null,
  usoLimiteValorPedido: null,
  carteiraLimiteSaldo: null,
  modoUso: MODO_USO_PADRAO,
});

export function preencherConfiguracao(dados) {
  const vazia = configuracaoVazia();

  return Object.keys(vazia).reduce((campos, campo) => {
    campos[campo] = !dados || dados[campo] === undefined ? vazia[campo] : dados[campo];

    return campos;
  }, {});
}

export function limitesUsoPreenchidos(dados) {
  return CAMPOS_LIMITE_USO.filter((tipo) => positivo(dados && dados[tipo.campo]));
}

export function tipoLimiteUso(dados) {
  const [primeiro] = limitesUsoPreenchidos(dados);

  return primeiro ? primeiro.chave : LIMITE_USO_NENHUM;
}

export function normalizarConfiguracao(form) {
  const campos = preencherConfiguracao(form);

  return {
    ...campos,
    avisoVencimentoDias: Number(campos.avisoVencimentoDias) || 0,
    usoLimitePercentualSaldo: positivo(campos.usoLimitePercentualSaldo),
    usoLimitePercentualPedido: positivo(campos.usoLimitePercentualPedido),
    usoLimiteValorPedido: positivo(campos.usoLimiteValorPedido),
    carteiraLimiteSaldo: positivo(campos.carteiraLimiteSaldo),
  };
}

export function payloadConfiguracao(form, tipo = tipoLimiteUso(form)) {
  const escolhido = tipoLimiteUsoPorChave(tipo);
  const normalizada = normalizarConfiguracao(form);

  CAMPOS_LIMITE_USO.forEach(({ campo }) => {
    if (campo !== escolhido.campo) normalizada[campo] = null;
  });

  return normalizada;
}

const vazioDigitado = (valor) => valor === null || valor === undefined || valor === "";

const casasDecimais = (valor) => {
  const [, decimais = ""] = String(Number(valor)).split(".");

  return decimais.length;
};

function validarLimiteUso(form, tipo) {
  const escolhido = tipoLimiteUsoPorChave(tipo);

  if (!escolhido.campo) return null;

  const valor = vazioDigitado(form[escolhido.campo]) ? 0 : Number(form[escolhido.campo]);

  if (Number.isNaN(valor) || valor <= 0) return `Informe o limite em ${escolhido.label} ou escolha Sem limite.`;
  if (escolhido.percentual && valor > PERCENTUAL_MAXIMO) return `O limite em ${escolhido.label} não pode passar de ${PERCENTUAL_MAXIMO}%.`;
  if (casasDecimais(valor) > 2) return `O limite em ${escolhido.label} aceita no máximo 2 casas decimais.`;

  return null;
}

export function validarConfiguracao(form, tipo = tipoLimiteUso(form)) {
  const erroLimite = validarLimiteUso(form, tipo);

  if (erroLimite) return erroLimite;

  const dias = vazioDigitado(form.avisoVencimentoDias) ? 0 : Number(form.avisoVencimentoDias);

  if (!Number.isInteger(dias) || dias < 0 || dias > DIAS_MAXIMO_AVISO) {
    return `A antecedência do aviso precisa ser um número inteiro de dias, de 0 a ${DIAS_MAXIMO_AVISO}.`;
  }

  return null;
}

export function exemploLimitesUso(form, tipo = tipoLimiteUso(form)) {
  const escolhido = tipoLimiteUsoPorChave(tipo);

  if (!escolhido.campo) return "Sem limite, o cliente pode usar todo o saldo, até o total do pedido.";

  const valor = positivo(form[escolhido.campo]);

  if (!valor) return `Informe o limite em ${escolhido.label} para ver o exemplo.`;

  const contexto = `Com ${formatMoney(EXEMPLO_SALDO_CARTEIRA)} na carteira e um pedido de ${formatMoney(EXEMPLO_VALOR_PEDIDO)}`;
  const limites = {
    SALDO: { valor: (EXEMPLO_SALDO_CARTEIRA * valor) / 100, texto: `${formatPercentual(valor)} do saldo` },
    PEDIDO: { valor: (EXEMPLO_VALOR_PEDIDO * valor) / 100, texto: `${formatPercentual(valor)} do pedido` },
    VALOR: { valor, texto: `${formatMoney(valor)} por pedido` },
  };
  const limite = limites[escolhido.chave];
  const usado = Math.min(EXEMPLO_SALDO_CARTEIRA, EXEMPLO_VALOR_PEDIDO, limite.valor);

  return `${contexto}, com o limite de ${limite.texto} o cliente usa até ${formatMoney(usado)}.`;
}

export function classeSaldo(saldo) {
  if (saldo > 0) return "cashback-valor--positivo";
  if (saldo < 0) return "cashback-valor--negativo";

  return "";
}
